import React from 'react';
import css from './ExclusiveTrainingFormFields.module.css';
import { FormattedMessage } from 'react-intl';

import TitleInputField from '../TitleInputField';
import PriceInputField from '../PriceInputField';
import HoursInputField from '../HoursInputField';
import PersonalizationFormField from '../PersonalizationFormField';
import LocationInputFormField from '../LocationInputFormField/LocationInputFormField';
import BookingTimeFormField from '../BookingTimeFormField/BookingTimeFormField';
import classNames from 'classnames';

const TRAINING_CONFIG = {
  '1-on-1 Coaching': {
    needsLocation: true,
    descriptionLabel: 'Describe the 1-on-1 Coaching',
    descriptionPlaceholder:
      'e.g. Private 2-hour session focusing on footwork, shooting form, and conditioning...',
  },
  'Group Training': {
    needsLocation: true,
    descriptionLabel: 'Describe the Group Training',
    descriptionPlaceholder:
      'e.g. 90-minute workout for 8-12 athletes: speed, agility, strength drills...',
  },
  'Film Breakdown Session': {
    needsLocation: true,
    descriptionLabel: 'Describe the Film Breakdown Session',
    descriptionPlaceholder:
      'e.g. 2-hour film room session reviewing game tape, teaching reads and adjustments...',
  },
  'Virtual Training Camp': {
    needsLocation: false,
    descriptionLabel: 'Describe the Virtual Training Camp',
    descriptionPlaceholder:
      'e.g. 5-day online camp via Zoom: daily workouts, Q&A, guest coaches...',
  },
};

const ExclusiveTrainingFormFields = ({ formId, values, listing }) => {
  const selectedTitle = values?.title;
  const config = selectedTitle ? TRAINING_CONFIG[selectedTitle] : null;

  // Show only title + price until a type is selected
  if (!selectedTitle || !config) {
    return (
      <>
        <div className={css.offeringBlock}>
          <div className={css.offeringHeader}>
            <h4>
              <FormattedMessage id="ExclusiveTrainingFormFields.sectionHeading" />
            </h4>
          </div>
        </div>

        <div className={css.formRow}>
          <div className={css.formFld}>
            <TitleInputField label="Type" id="title" fieldName="title" />
          </div>
          <div className={css.formFld}>
            <PriceInputField formId={formId} />
          </div>
        </div>
      </>
    );
  }

  const {
    needsLocation,
    descriptionLabel,
    descriptionPlaceholder = 'Tell us more about the training session...',
  } = config;

  return (
    <>
      <div className={css.offeringBlock}>
        <div className={css.offeringHeader}>
          <h4>
            <FormattedMessage id="ExclusiveTrainingFormFields.sectionHeading" />
          </h4>
        </div>
      </div>

      <div className={css.formRow}>
        <div className={css.formFld}>
          {/* Title (Type) */}
          <TitleInputField label="Type" id="title" fieldName="title" />
        </div>
        <div className={css.formFld}>
          {/* Price */}
          <PriceInputField formId={formId} />
        </div>
      </div>

      <div className={classNames(css.formRow, css.fullWidth)}>
        <div className={css.formFld}>
          {/* Hours */}
          <HoursInputField
            label="How many hours?"
            fieldName="hours"
            id="hours"
            placeholder="e.g. 2 hours"
          />
        </div>
      </div>

      {/* Booking Time */}
      <BookingTimeFormField listing={listing} />
      <div className={classNames(css.formRow, css.fullWidth)}>
        <div className={classNames(css.formFld, css.fieldGroup)}>
          {/* Location - Only for in-person sessions */}
          {needsLocation && (
            <LocationInputFormField
              fieldName="location"
              label="Location"
              placeholder="Gym name, address, city, or facility details"
            />
          )}
        </div>
      </div>

      {/* Description */}
      <PersonalizationFormField
        label={descriptionLabel}
        placeholder={descriptionPlaceholder}
        fieldName="personalizationText"
        rows={6}
      />

      {/* Optional note for virtual */}
      {!needsLocation && (
        <div className={css.infoNote}>
          <p>
            <strong>
              <FormattedMessage id="CreativeMediaFormFields.virtualSessionNotePrefix" />
            </strong>{' '}
            <FormattedMessage id="CreativeMediaFormFields.virtualSessionNoteText" />
          </p>
        </div>
      )}
    </>
  );
};

export default ExclusiveTrainingFormFields;
